<div class="flex flex-col flex-auto min-w-0">
  <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8">
    <div class="absolute inset-x-0 bottom-0" *ngIf="isLoading"></div>
    <div>
      <div class="text-4xl font-extrabold tracking-tight leading-none">{{ 'ORGANIZATION.LANDING_PAGE.TITLE' | transloco }}</div>
    </div>
    <div class="flex flex-shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
      <button class="ml-4" mat-flat-button [color]="'primary'" [routerLink]="fullCreateOrganizationPath">
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">{{ 'ORGANIZATION.LANDING_PAGE.CREATE_ORGANIZATION' | transloco }}</span>
      </button>
    </div>
  </div>
  <div *ngIf="organizations.length === 0; else displayOrgs" class="flex justify-center items-center flex-1">
    <div class="">
      <span class="ml-2 mr-1">{{ 'ORGANIZATION.LANDING_PAGE.NO_ORGANIZATIONS' | transloco }}</span>
    </div>
  </div>
</div>

<ng-template #displayOrgs>
  <div class="flex-auto border-t -mt-px pt-4 sm:pt-6 p-16">
    <div class="ml-1.5 leading-6 truncate text-secondary">{{ organizations.length }} {{ 'ORGANIZATION.LANDING_PAGE.MESSAGE' | transloco }}</div>
    <div class="flex items-center"></div>
    <div *ngIf="organizations" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
      <ng-container *ngFor="let org of organizations">
        <div
          class="flex flex-col flex-auto items-center bg-card shadow rounded-2xl overflow-hidden cursor-pointer"
          (click)="navigateToOrganizationProfilePage(org)">
          <div class="flex flex-col flex-auto w-full p-8 text-center">
            <div class="mt-6 font-medium">{{ org.name }}</div>
            <div class="text-secondary">{{ org.title }}</div>
          </div>
          <!-- Email & Phone -->
          <div class="flex items-center w-full border-t divide-x"></div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
